const initialState = { data: null, loading: true };

export const GetWorkOrderByIdReducer = (state = initialState, action) => {
  switch (action.type) {
    case "get_workorder_byid":
      return { ...state, data: action.data, loading: false };
    default:
      return state;
  }
};
